import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_6_3_1,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-6-3-1',
    templateUrl: './exemption_6_3_1.component.html',
    styleUrls: ['./exemption_6_3_1.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_6_3_1Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_6_3_1;

  dangerousGoods?: DangerInformation;
  portVisitUtils = PortvisitUtils;

  vessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  relationTypes: string[] = [
    'The substances sodium hydroxide, potassium hydroxide, phosphoric acid, sulphuric acid, or any other substance with low vapour pressure',
    'Exemption for use of vapour return in connection with uninerted seagoing vessel loading (does not apply to transhipment of substances listed in Annex I of the Port By-Laws)',
    'The cargo tank in question on the seagoing vessel is inert and the inland barge is not inert and it is a closed ADN substance',
    'The vapours are captured in another alternative way by an appropriate facility (Vapour Recovery Unit)'
  ];

  resetVesselInfo() {
    this.exemption.vesselENI = '';
    this.exemption.vesselIMO = '';
    this.exemption.vesselNameENI = '';
    this.exemption.vesselNameIMO = '';
  }
}
